module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Westerholm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Stephen Westerholm")]), _vm._v(" is professor emeritus of early Christianity at McMaster University, Hamilton, Ontario. His other books include "), _c('I', [_vm._v("Reading Sacred Scripture: Voices from the History of Biblical Interpretation")]), _vm._v(" (with Martin Westerholm), "), _c('I', [_vm._v("Justification Reconsidered: Rethinking a Pauline Theme")]), _vm._v(", and "), _c('I', [_vm._v("Understanding Paul: The Early Christian Worldview of the Letter to the Romans.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19Ysv87/tc-custom/9781467430975.jpg?1728851752739",
      "alt": "This image is the cover for the book Perspectives Old and New on Paul"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perspectives Old and New on Paul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Here, finally, is a much-needed review and analysis of the divergent interpretations of Paul. With a clear head and winsome sense of humor, Stephen Westerholm compares the traditional understanding of Paul to more recent readings, drawing on the writings of key figures in the debate both past and present."), _c('br'), _c('br'), _vm._v("Westerholm first offers a detailed portrait of the \"Lutheran\" Paul, including the way such theologians as Augustine, Luther, Calvin, and Wesley have traditionally interpreted \"justification by faith\" to mean that God declares sinners \"righteous\" by his grace apart from \"works.\" Westerholm then explores how Paul has fared in the twentieth century, in which \"New Perspective\" readings of Paul see him teaching that Gentiles need not become Jews or observe Jewish law to be God's people. The final section of the book looks anew at disputed areas of Paul's theological language and offers compelling discussion on the place of both justification by faith and Mosaic law in divine redemption.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0